import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_TERMINAL_TICKET_HISTORY_API,
  timeout: 5000,
});

export default {
  async getTicketsHistory(user, config, timeFrom, timeTo, count) {
    const headers = {
      Authorization: `Bearer ${user.auth.token}`,
      'HTTP-X-NAB-BETSHOP-ID': config.betshop.id,
      'HTTP-X-NAB-COMPANY-ID': config.companyData.id,
      'HTTP-X-NAB-DEVICE-UUID': config.device.deviceUuid,
      'HTTP-X-NAB-DP': 'AdminTerminal',
      'SEVEN-LOCALE': config.locale,
    };

    const response = await http.get(`/${config.productId}.json`, {
      headers,
      params: {
        deviceUuid: config.device.deviceUuid,
        timeFrom,
        timeTo,
        count,
      },
    });

    return response.data;
  },
};
